import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class LoginService {
	constructor(private http: HttpClient) { }

	public verifyUserId(userId): Observable<any> {
		return this.http.post(
			environment.BASE_URL_PROFILE + "auth/verifyUser",
			userId
		);
	}
	public authenticate(payload): Observable<any> {
		const response: any = this.http.post<any>(
			environment.BASE_URL_PCD + "auth/authenticate",
			payload
		);
		return response;
	}
	public getToken(payload): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.append(
			"Authorization",
			"Basic " + btoa(payload.username + ":" + payload.password)
		);
		headers = headers.append("X-Requested-With", "XMLHttpRequest");
		let httpOptions = { headers: headers };
		return this.http.get(
			"http://10.87.204.248/hec-profile-rest/rest/auth/getToken",
			httpOptions
		);
	}

	public getIpLocation(): Observable<any> {
		// return this.http.get("https://api64.ipify.org?format=json");
		return this.http.get("https://freegeoip.app/json/");
	}
	// public getExtactLocation(ip:any): Observable<any> {
	// 	return this.http.get(`https://ipinfo.io/${ip}?token=d921991afffd2c`);
	// }


	public cancelApplication(payload, login): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.append(
			"Authorization",
			"Basic " + btoa(login["username"] + ":" + login["password"])
		);
		headers = headers.append("X-Requested-With", "XMLHttpRequest");
		let httpOptions = { headers: headers };
		return this.http.post(
			environment.BASE_URL_DAS + "das/cancelApplication",
			payload,
			httpOptions
		);
	}

	public test(id): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.append(
			"Authorization",
			"Basic " + btoa("4250148663989" + ":" + "Racespeed2312")
		);
		headers = headers.append("X-Requested-With", "XMLHttpRequest");
		let httpOptions = { headers: headers };
		return this.http.get(
			environment.BASE_URL_DAS + "das/startInstance/" + id,
			httpOptions
		);
	}
}
